const DECIMAL_COMPARISON_EPSILON = 1e-9;

/** Checks the number of decimal places of a parsed number, tolerating floating-point noise. */
export const hasAtMostDecimalPlaces = (value: number, maxDecimalPlaces: number) => {
  const shifted = value * 10 ** maxDecimalPlaces;

  return Math.abs(shifted - Math.round(shifted)) < DECIMAL_COMPARISON_EPSILON;
};
